import { ShoppingCart } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@tellescope/design-system";

interface CartIconButtonProps {
  itemCount: number;
  onClick: () => void;
  className?: string;
}

/** Persistent cart icon shown in the global nav chrome whenever a shop block exists anywhere in the portal schema. */
export const CartIconButton = ({ itemCount, onClick, className }: CartIconButtonProps) => {
  const { t } = useTranslation("shop");

  return (
    <Button
      variant="ghost"
      iconOnly
      hoverLabel={t("Open cart")}
      data-test="global-cart-icon"
      onClick={onClick}
      className={className ?? "relative rounded-full"}
    >
      <ShoppingCart className="h-5 w-5" />
      {itemCount > 0 && (
        <span className="absolute -top-0.5 -right-0.5 w-4 h-4 rounded-full text-[10px] font-bold flex items-center justify-center bg-primary text-primary-foreground">
          {itemCount > 9 ? "9+" : itemCount}
        </span>
      )}
    </Button>
  );
};
